/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import Button from "../components/UI/Button/Button"
import { useLoginLogout } from "../components/hooks"
import { useHistory } from "react-router-dom"
import { Theme } from "../components/types"

function LandingScreen() {
    const { label, handler, isAuthenticated } = useLoginLogout()

    const history = useHistory()

    const handleNav = () => {
        history.push(`/organization`)
    }

    return (
        <div css={styles.root}>
            <div css={styles.container}>
                <Button
                    onClick={handler}
                    color={isAuthenticated ? "secondary" : "primary"}
                    size="large"
                    css={styles.btn}
                >
                    {label}
                </Button>
                {isAuthenticated && (
                    <Button onClick={handleNav} size="large" css={styles.btn}>
                        Alkalmazás
                    </Button>
                )}
            </div>
        </div>
    )
}

export default LandingScreen

const styles = {
    root: css`
        display: flex;
        justify-content: center;
    `,
    container: css`
        display: flex;
        flex-direction: column;
        align-items: center;
    `,
    btn: (theme: Theme) => css`
        margin: ${theme.spaces.smallScale.s};
    `,
}
